/**
 * FixedField — a read-only "fixed" field: plain label + value text, NOT a
 * disabled input. Used when Region/Venue are set from the launch page.
 *
 * Extracted from LocationStep so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
export function FixedField({
  label,
  value,
  ariaLabel,
  error,
}: {
  label: string;
  value: string;
  ariaLabel: string;
  error?: string;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}>{label}</span>
      <span aria-label={ariaLabel} style={{ fontSize: 13, color: 'var(--nb-ink)' }}>
        {value || '—'}
      </span>
      {error && (
        <span role="alert" style={{ fontSize: 10.5, color: 'var(--nb-risk)' }}>
          {error}
        </span>
      )}
    </div>
  );
}
